<template>
    <button
        :class="[getClass]" :type="type">
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: 'green'
            },
            type: {
                type: String,
                default: 'button'
            }
        },
        data() {
            return {
                defaultClass: 'select-none mx-[3px] inline-flex items-center justify-center h-10 gap-2 px-5 text-sm font-medium tracking-wide transition duration-300 rounded focus-visible:outline-none whitespace-nowrap disabled:cursor-not-allowed disabled:shadow-none'
            }
        },
        computed: {
            getClass() {
                return this.createColor()
            }
        },
        methods: {
            createColor() {
                const colors = {
                    blue: ' text-white bg-blue-500 hover:bg-blue-600 focus:bg-blue-700 disabled:border-blue-300 disabled:bg-blue-300',
                    gray: ' text-white bg-gray-500 hover:bg-gray-600 focus:bg-gray-700 disabled:border-gray-300 disabled:bg-gray-300',
                    green: ' text-white bg-emerald-500 hover:bg-emerald-600 focus:bg-emerald-700 disabled:border-emerald-300 disabled:bg-emerald-300',
                    red: ' text-white bg-red-500 hover:bg-red-600 focus:bg-red-700  disabled:border-red-300 disabled:bg-red-300',
                    yellow: ' text-white bg-yellow-500 hover:bg-yellow-600 focus:bg-yellow-700 disabled:border-yellow-300 disabled:bg-yellow-300',
                    cyan: ' text-white bg-cyan-500 hover:bg-cyan-600 focus:bg-cyan-700 disabled:border-cyan-300 disabled:bg-cyan-300',
                    white: ' text-slate-800 bg-white hover:bg-gray-200 focus:bg-gray-200 disabled:border-gray-300 disabled:bg-gray-300',
                    slate: ' text-white bg-slate-600 hover:bg-slate-500 focus:bg-slate-500  disabled:border-slate-800 disabled:bg-slate-800'
                }

                if ( this.color === 'blue' || this.color === 'primary' ) {
                    return this.defaultClass + colors.blue
                } else if ( this.color === 'gray' || this.color === 'secondary' ) {
                    return this.defaultClass + colors.gray
                } else if ( this.color === 'green' || this.color === 'success' ) {
                    return this.defaultClass + colors.green
                } else if ( this.color === 'red' || this.color === 'danger' ) {
                    return this.defaultClass + colors.red
                } else if ( this.color === 'yellow' || this.color === 'warning' ) {
                    return this.defaultClass + colors.yellow
                } else if ( this.color === 'cyan' || this.color === 'info' ) {
                    return this.defaultClass + colors.cyan
                } else if ( this.color === 'white' || this.color === 'light' ) {
                    return this.defaultClass + colors.white
                } else if ( this.color === 'slate' || this.color === 'dark' ) {
                    return this.defaultClass + colors.slate
                } else {
                    return this.defaultClass + colors.blue
                }
            }
        }
    }

</script>
